<template>
  <div class="content-box">
    <div class="content-header" ref="searchBoxRef">
      <el-input class="input" v-model="queryForm.productName" placeholder="请输入产品名称" clearable></el-input>
      <el-input class="input" v-model="queryForm.presCategoryName" placeholder="请输入产品分类名称" clearable></el-input>
      <el-input class="input" v-model="queryForm.code" placeholder="请输入产品编码" clearable></el-input>
      <el-input class="input" v-model="queryForm.remark" placeholder="请输入产品备注" clearable></el-input>
      <el-input class="input" v-model="queryForm.storeName" placeholder="请输入关联门店" clearable></el-input>
      <el-input class="input" v-model="queryForm.storeShowName" placeholder="请输入门店外显名称" clearable></el-input>
      <el-button @click="searchData" type="primary">搜索</el-button>
      <el-button type="plain" icon="el-icon-plus" @click="add">新增食养二维码</el-button>
    </div>
    <div class="table-list">
      <ETable :columns="columns" :data="tableData" style="width: 100%" :max-height="tableMaxheight" :header-cell-style="headerCellStyle"
        :cell-style="cellStyle" border>
        <template #merchantName="{ row }">
          <el-tooltip placement="top" :content="row.merchantName" v-ak-tooltip-auto-show>
            <span class="ellipsis-text-2">{{ row.merchantName || '默认产品' }}</span>
          </el-tooltip>
        </template>
        <template #storeName="{ row }">
          <el-tooltip placement="top" :content="row.storeName" v-ak-tooltip-auto-show>
            <span class="ellipsis-text-2">{{ row.storeName }}</span>
          </el-tooltip>
        </template>
        <template #storeShowName="{ row }">
          <el-tooltip placement="top" :content="row.storeShowName" v-ak-tooltip-auto-show>
            <span class="ellipsis-text-2">{{ row.storeShowName }}</span>
          </el-tooltip>
        </template>
        <template #remark="{ row }">
          <el-tooltip placement="top" :content="row.remark" v-ak-tooltip-auto-show>
            <span class="ellipsis-text-2" v-html="formatTextarea(row.remark)"></span>
          </el-tooltip>
        </template>
        <template #codeManage="{ row }">
          <el-button type="text" @click="handleDownload(row)">下载二维码</el-button>
          <el-button type="text" @click="handleCode(row)">下载编码</el-button>
        </template>
        <template #action="{ row }">
          <el-button type="text" @click="bindStore(row)">关联门店</el-button>
        </template>
      </ETable>
      <el-pagination style="margin-top: 20px" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="itemTotal"></el-pagination>
    </div>
    <AddProduct @syncList="getData" :visible.sync="dialogVisible" />
    <ProductListBindStore @syncList="getData" :visible.sync="bindStoreVisible"
      :bindStoreProductInfo="bindStoreProductInfo" :bindStoreApi="bindStoreApi" />
  </div>
</template>
<script>
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import { getCareProductList, downloadProductQrCode, downloadProductCode } from "@/api/product"
import ProductListBindStore from "../product-list/components/bindStore.vue"
import AddProduct from "./components/addProduct.vue";
import { formatTextarea } from "@/utils/common";
import { relationStore } from "@/api/product";

const curDomain = `${window.location.origin}`;

@Component({ name: 'productCode-index',
  components: { ETable, ProductListBindStore, AddProduct }
})
export default class productCode extends Mixins(loading, tablePagination, Resize) {
  EditDialogVisible = false;
  dialogTitle = "";
  dialogVisible = false;

  statusOptions = [
    {
      label: "启用",
      value: 1
    },
    {
      label: "禁用",
      value: 0
    }
  ]

  bindStoreVisible = false;
  bindStoreProductInfo = {};
  bindStoreApi = relationStore;

  queryForm = {
    productName: "",
    presCategoryName: "",
    code: "",
    remark: "",
    storeName: "",
    storeShowName: "",
  };
  itemTotal = 0;
  tableData = [];

  columns = [
    { label: "序号", prop: "id" },
    { label: "产品分类名称", prop: "presCategoryName", minWidth: "120px" },
    { label: "产品名称", prop: "productName", minWidth: "150px" },
    { label: "品牌", prop: "merchantName", minWidth: "120px" },
    { label: "关联门店", prop: "storeName", minWidth: "160px" },
    { label: "关联外显门店", prop: "storeShowName", minWidth: "160px" },
    { label: "编码数量", prop: "codeNumber" },
    { label: "已消耗数量", prop: "expendNumber", width: "120px" },
    { label: "有效编码管理", prop: "codeManage", minWidth: "180px" },
    { label: "最后下载时间", prop: "downloadTime", width: "160px" },
    { label: "操作人", prop: "createdBy", width: "120px" },
    { label: "备注", prop: "remark", width: "120px" },
    { label: "操作", prop: "action", width: "120px", fixed: "right" },
  ]
  mounted() {
    this.getData();
    this.windowResize();
  }

  formatTextarea(content) {
    return formatTextarea(content);
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  add() {
    this.dialogVisible = true;
  }

  getData() {
    const params = {
      ...this.queryForm,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
    }
    this.showLoading();
    getCareProductList(params).then((res) => {
      this.tableData = res.data.list;
      this.itemTotal = res.data.total;
    })
  }

  handleDownload(row) {
    downloadProductQrCode({
      productId: row.id
    }).then(res => {
      let data = new Blob([res], { type: "application/zip" });
      let url = window.URL.createObjectURL(data);
      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `二维码【${row.merchantName || "默认产品"}-${row.presCategoryName}-${row.productName}】.zip`)//下载文件名称
      link.click();
      window.URL.revokeObjectURL(url);
      this.getData();
    }).catch(err => { })
  }

  handleCode(row) {
    downloadProductCode({
      productId: row.id
    }).then(res => {
      let data = new Blob([res], { type: "application/zip" });
      let url = window.URL.createObjectURL(data);
      let link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `编码【${row.merchantName || "默认产品"}-${row.presCategoryName}-${row.productName}】.zip`)//下载文件名称
      link.click();
      window.URL.revokeObjectURL(url);
      this.getData();
    }).catch(err => { })
  }

  bindStore(row) {
    this.bindStoreVisible = true;
    this.bindStoreProductInfo = { ...row }
  }
}

</script>
<style lang="scss" scoped>
@import "@/styles/app";

.content-box {
  background: #edf0f9;
}

.content-header {
  background: #ffffff;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 20px;
}

.table-list {
  margin-top: 20px;
  background: #ffffff;
  border-radius: 8px;
  padding: 40px;
}

.input {
  width: 240px;
  margin-right: 12px;
  margin-bottom: 10px;
}

.el-button {
  margin-right: 12px;
  margin-left: 0;
}

.button-on {
  font-size: 14px;
  font-weight: 400;
}

.status-off {
  font-size: 14px;
  font-weight: 400;
  color: #ff6700;
}
</style>